/// <amd-module name="typeahead/core/SearchParametersUpdater"/>

import {ProblemOrigin} from "typeahead/core/logging/ProblemOrigin";
import {Severity} from "typeahead/core/logging/Severity";
import TypeaheadErrorLogger from "typeahead/core/logging/TypeaheadErrorLogger";
import {Suggestion} from "typeahead/core/Suggestion";
import {Optional} from "typeahead/core/util/Optional";

const featureExtractorByElement: {[element: string]: string} = {
    airport_code_element: "getTla",
    category_element: "getCategory",
    city_element: "getCity",
    country_code_element: "getCountryIsoCode2",
    heds_element: "getIsHeds",
    hotel_id_element: "getHotelId",
    lat_long_element: "getLatLong",
    region_id_element: "getRegionId",
    region_type_element: "getType",
    station_code_element: "getStationCode",
};

function updateElement (suggestion: Suggestion, elementId: string, valueGetter: string): void {
    let jqElement = $("#" + elementId);
    let newValue = "";
    if (jqElement.length > 0) {
        if (suggestion) {
            if (_.isFunction(suggestion[valueGetter])) {
                let v: Optional<string> = suggestion[valueGetter]();
                if (v.isPresent()) {
                    newValue = v.get();
                }
            } else {
                TypeaheadErrorLogger.log(
                    new Error("" + valueGetter + " is not a method of Suggestion"),
                    Severity.MustFix, ProblemOrigin.UniversalTypeahead);
            }
        }
        jqElement.val(newValue);

        triggerDomElementChange(suggestion, jqElement);
    }
}

function updateSearchName(searchQuery: string, suggestion: Suggestion, elementId: string) {
    /* This logic is applicable only to Hotels tab in Storefront. When a hotel is selected from the typeahead
    suggestions, the destination parameter in the search url needs to be set to the hotel city instead of the hotel name
     */
    let jqElement = $("#" + elementId);
    jqElement.val(suggestion ? (suggestion.getHotelId().isPresent() && suggestion.getCity().isPresent() ?
            suggestion.getCity().get() : suggestion.getDisplayText()) : searchQuery);

    triggerDomElementChange(suggestion, jqElement);
}

function triggerDomElementChange(suggestion: Suggestion, jqElement: JQuery) {
    if (!suggestion || suggestion.shouldTriggerDomElementChangeOnSelection()) {
        jqElement.trigger("change");
    }
}

export function updateForSuggestion(
    searchQuery: string,
    suggestion: Suggestion,
    elementIdByElementKey: {[elementKey: string]: string }): void {
    for (let element in featureExtractorByElement) {
        if (featureExtractorByElement.hasOwnProperty(element)) {
            updateElement(suggestion, elementIdByElementKey[element], featureExtractorByElement[element]);
        }
    }

    // update search_name
    updateSearchName(searchQuery, suggestion, elementIdByElementKey.search_name_element);
}
